import { __makeTemplateObject } from "tslib";
import styled from 'styled-components';
import { Color } from '../../theme/Color/Color';
import { gray40Color, secondaryMainColor, } from '../../utils/styled-components/color-mixins/color-mixins';
/* Styled ProgressBar */
export var StyledProgressBar = styled('div')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: relative;\n  height: 4px;\n  width: 100%;\n  display: flex;\n  background-image: linear-gradient(\n    0deg,\n    transparent,\n    transparent 25%,\n    ", " 25%,\n    ", " 75%,\n    transparent 75%\n  );\n"], ["\n  position: relative;\n  height: 4px;\n  width: 100%;\n  display: flex;\n  background-image: linear-gradient(\n    0deg,\n    transparent,\n    transparent 25%,\n    ", " 25%,\n    ", " 75%,\n    transparent 75%\n  );\n"])), gray40Color, gray40Color);
StyledProgressBar.displayName = 'StyledProgressBar';
/* Styled ProgressBarFill */
export var StyledProgressBarFill = styled('div')(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  position: absolute;\n  height: 4px;\n  width: ", "%;\n  left: ", "%;\n  background-image: linear-gradient(\n    ", "\n  );\n  border-radius: ", ";\n"], ["\n  position: absolute;\n  height: 4px;\n  width: ", "%;\n  left: ", "%;\n  background-image: linear-gradient(\n    ",
    "\n  );\n  border-radius: ",
    ";\n"])), function (_a) {
    var percent = _a.percent, _b = _a.start, start = _b === void 0 ? 0 : _b;
    return Math.max(percent - start, 0);
}, function (_a) {
    var _b = _a.start, start = _b === void 0 ? 0 : _b;
    return start;
}, function (_a) {
    var color = _a.color, theme = _a.theme;
    var colorCode = color ? Color[color] : secondaryMainColor({ theme: theme });
    return "90deg, " + colorCode + " 0% , " + colorCode;
}, function (_a) {
    var _b = _a.roundCorners, roundCorners = _b === void 0 ? 'all' : _b;
    if (roundCorners === 'left')
        return '2px 0px 0px 2px';
    if (roundCorners === 'right')
        return '0px 2px 2px 0px';
    return '2px';
});
StyledProgressBarFill.displayName = 'StyledProgressBarFill';
var templateObject_1, templateObject_2;
//# sourceMappingURL=ProgressBar.styled.js.map